var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11C7.44769 11 7 11.4477 7 12C7 12.5523 7.44769 13 8 13H12C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11H8Z",
    fill: "#0043A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16C7 15.4477 7.44769 15 8 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H8C7.44769 17 7 16.5523 7 16Z",
    fill: "#0043A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 18H18C19.6569 18 21 16.6569 21 15V5C21 3.34314 19.6569 2 18 2H10C8.34314 2 7 3.34314 7 5V6H6C4.34314 6 3 7.34314 3 9V19C3 20.6569 4.34314 22 6 22H14C15.6569 22 17 20.6569 17 19V18ZM10 4C9.44769 4 9 4.44772 9 5V6H14C15.6569 6 17 7.34314 17 9V16H18C18.5523 16 19 15.5523 19 15V5C19 4.44772 18.5523 4 18 4H10ZM15 9C15 8.44772 14.5523 8 14 8H6C5.44769 8 5 8.44772 5 9V19C5 19.5523 5.44769 20 6 20H14C14.5523 20 15 19.5523 15 19V9Z",
    fill: "#0043A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5C2 4.5 2 3 4.5 3",
    stroke: "#0043A1",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57605 2.77067L4.21484 1L4.36611 4.88914L6.57605 2.77067Z",
    fill: "#0043A1",
    stroke: "#0043A1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendback);
export default __webpack_public_path__ + "static/media/sendback.91c5f3aa552e718b04735a49a983ffec.svg";
export { ForwardRef as ReactComponent };